import Vue from 'vue'
import VueWaypoint from 'vue-waypoint'
import App from './App.vue'

Vue.use(VueWaypoint);

Vue.config.productionTip = false

const yddvizApp = {
  onMount: () => {
    new Vue({
      render: h => h(App)
    }).$mount('#app-2019-11-tuloryhmat')
  }
};

yddvizApp.projectName = 'app-2019-11-tuloryhmat';

if (window.plusApp === undefined) {
  window.plusApp = {};
}
if (window.plusApp[yddvizApp.projectName] === undefined) {
  window.plusApp[yddvizApp.projectName] = yddvizApp;
  window.plusApp[yddvizApp.projectName].onMount();
}
